var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid h-full"},[_c('router-view'),_vm._v(" "),_vm._l((_vm.icons),function(icon,index){return _c('div',{key:index,staticClass:"icon relative",style:(_vm.background(icon))},[_c('overdrive',{attrs:{"id":icon.id}},[_c('router-link',{staticClass:"pin absolute",attrs:{"to":_vm.url(icon)}})],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0403a528","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconIndex.vue
// module id = null
// module chunks = 